import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, firstValueFrom } from 'rxjs';
import { EncryptService } from './encrypt.service';
import { RevokeTokenService } from "./revoke-token.service";

@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  private API_URL = environment.api;
  constructor(
    private httpClient: HttpClient,
    private encryptService: EncryptService,
    private revokeTokenService: RevokeTokenService
    ) {

    }

  // Author: Oswaldo Coronel.
  // Date: 26.02.2025.
  // Description: Logout the user from cognito in all devices.
  logOutAll(): Observable<any> {
    const endpoint = `${this.API_URL}security/logout`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + sessionStorage.getItem('tokenLogIn'),
        'accountCd': environment.keycloakRealm,
        'channelId': 'valorProvisional'
      })
    };
    const body = {};

    return this.httpClient.post(endpoint, body, httpOptions);
  }

  async logOut() {
    try {
      await this.revokeToken();
      sessionStorage.removeItem('tokenLogIn');
      sessionStorage.removeItem('codeVerify');
      sessionStorage.removeItem('refreshLogIn');
      window.location.href = window.location.origin + '/home';
    } catch (error) {
      console.error('Error al revocar el token:', error);
    }
  }
  
  async revokeToken() {
    return firstValueFrom(this.revokeTokenService.revokeToken());
  }
}

